var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-chain"},[_c('div',{staticClass:"change-chain-top-bar"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.chainName))]),_c('el-button',{staticClass:"change-btn",on:{"click":function($event){return _vm.change()}}},[_vm._v("变更")])],1),_c('update-chain',{ref:"updateChainRef",on:{"updateChainName":_vm.initChain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }